import { __assign } from 'tslib';
import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ElementSummary";
var classes = {
    actions: "".concat(PREFIX, "-actions"),
    actionsContainer: "".concat(PREFIX, "-actionsContainer"),
    cardContent: "".concat(PREFIX, "-cardContent")
};
var StyledElementSummary = styled(Card, {
    shouldForwardProp: function (prop) { return prop !== "selected" && prop !== "showFields"; }
})(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme, selected = _a.selected, showFields = _a.showFields;
    return (__assign(__assign(__assign(__assign({ display: "block", minHeight: "100%", outline: "2px solid transparent", width: "100%", textAlign: "left", padding: 0, borderRadius: "10px", boxShadow: "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px" }, (!showFields && {
        borderRadius: 0,
        outline: 0
    })), (_b = { "&:hover, &:focus-within": {
                boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.14)"
            } }, _b["&:hover .".concat(classes.actions, ", &:focus-within .").concat(classes.actions)] = {
        opacity: 1
    }, _b)), (selected && {
        outlineColor: theme.palette.primary.main
    })), (_c = {}, _c["& .".concat(classes.actionsContainer)] = {
        position: "relative",
        zIndex: !showFields ? 1 : 0
    }, _c["& .".concat(classes.actions)] = __assign(__assign({ position: "absolute", display: "block", right: 0, textAlign: "right", opacity: 0, transitionProperty: "opacity", transitionDuration: "0.3s", transform: "translateY(-50%)" }, (!showFields && {
        transform: "translateY(-120%)"
    })), (_d = { padding: theme.spacing(0, 1) }, _d[theme.breakpoints.down("sm")] = {
        padding: 0
    }, 
    // always opacity 1 for action buttons for device without over (i.e touch screen)
    _d["@media (hover: none)"] = {
        opacity: 1
    }, _d)), _c["& .".concat(classes.cardContent)] = {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        // Override default CardContent behavior
        padding: "".concat(theme.spacing(2.5), " ").concat(theme.spacing(1), " ").concat(theme.spacing(1), " ").concat(theme.spacing(1))
    }, _c)));
});

export { classes, StyledElementSummary as default };
//# sourceMappingURL=index.styled.js.map
